/* src/app/components/dialogs/eula-dialog/eula-dialog.component.scss */
.mat-mdc-dialog-actions {
  justify-content: space-between;
  padding-right: 8px;
}
:host-context(.dark-theme) h1 {
  color: #f2f2f2;
}
:host-context(.dark-theme) :host::ng-deep .mat-mdc-dialog-content p {
  background: #363636;
}
:host-context(.dark-theme) :host::ng-deep .mat-mdc-dialog-content p span {
  color: #f2f2f2;
}
/*# sourceMappingURL=eula-dialog.component.css.map */
